// Store
import { thunk } from './middleware';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';

// Reducers
import {uiReducer} from './Ui';
import {dealersReducer} from './Dealers';
import {modelsReducer} from './Models';
import {tradeinReducer} from './Tradein';

const combinedReducers = combineReducers({
  ui: uiReducer,
  dealers: dealersReducer,
  models: modelsReducer,
  tradein: tradeinReducer
});
let devTools = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers = devTools ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

export const createAppStore = (initialState) => createStore(combinedReducers, initialState, composeEnhancers(applyMiddleware(thunk)));

// https://github.com/zalmoxisus/redux-devtools-extension
